import { useEffect } from "react";
import { useSelector } from "react-redux";
import useFetchOrganizations from "../organizations/useFetchOrganizations";

// Compatibility hook for backward compatibility
const useGetPractices = () => {
  const { organizations } = useSelector((state: any) => state.organizations);
  const { fetchOrganizations } = useFetchOrganizations();

  useEffect(() => {
    fetchOrganizations();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Map organizations to practices for backward compatibility
  const practices =
    organizations?.map((org: any) => ({
      ...org,
      // Map organization fields to practice fields
      practiceName: org.name,
      practiceOwnerId: org.organizationOwnerId,
      // Keep other fields as they are
      uuid: org.uuid,
      treatmentType: org.treatmentType,
      practiceSize: org.practiceSize,
      address1: org.address1,
      address2: org.address2,
      state: org.state,
      zipcode: org.zipcode,
      phone: org.phone,
      logoId: org.logoId,
      logoUrl: org.logoUrl,
      slug: org.slug,
      createdAt: org.createdAt,
      updatedAt: org.updatedAt,
      numberOfUsers: org.numberOfUsers,
      status: org.status,
    })) || [];

  return { practices, fetchPractices: fetchOrganizations };
};

export { useGetPractices };
